<div class="modules-container">
    <kendo-treeview class="tree" [nodes]="this.treeNodes()" textField="label" kendoTreeViewExpandable [filterable]="true" [size]="'medium'"
        [isDisabled]="isNodeDisabled" kendoTreeViewFlatDataBinding idField="id" (nodeDragStart)="onDragStart2($event)"
        parentIdField="parentId">
        <ng-template kendoTreeViewNodeTemplate let-dataItem>
            <div class="treenode" [popover]="firstPopover" (dragstart)="onDragStart($event, dataItem.data)" [draggable]="dataItem.isDraggable" kendoPopoverAnchor
                showOn="hover">
                <div class="icon-wrapper">
                    <asset-icon [imgPath]="dataItem.icon" [defaultPath]="dataItem.defaultIcon"></asset-icon>
                </div>
                <span>{{dataItem.label}}</span>
            </div>
            <kendo-popover #firstPopover [title]="dataItem.data.name" [width]="400" position="right">
                <ng-template kendoPopoverBodyTemplate>
                    <div markdown [data]="this.moduleRepo.getDescription(dataItem.data)"></div>
                    <div *ngIf="this.jsBridgeService.isDev()">Origin: {{dataItem.data.origin}}</div>
                </ng-template>

            </kendo-popover>
        </ng-template>
    </kendo-treeview>

    <!-- <kendo-textbox placeholder="Zoek" [(value)]="this.filter"></kendo-textbox>
    @for (slot of filteredSlots(); track slot.key) {
        <slot-group [slot]="slot"></slot-group>
    } -->
    <!-- @for (module of modules(); track module.key) {
    <div class="module" draggable="true" (dragstart)="onDragStart($event, module)" kendoPopoverAnchor
        [popover]="firstPopover" showOn="hover">
        <div [style]="{width: '64px', height: '64px'}">
            <asset-icon [imgPath]="module.icon"></asset-icon>
        </div>
        <span class="module_name">{{module.name}}</span>
    </div>
    <kendo-popover #firstPopover [title]="module.name" [width]="400" position="right">
        <ng-template kendoPopoverBodyTemplate>
            <div markdown [data]="this.moduleRepo.getDescription(module)"></div>
        </ng-template>

    </kendo-popover>
    } -->
</div>